import React, { Component } from "react";
import { cloneDeep } from "lodash";
import { Form, Input, Modal, Row, Col, Upload } from "antd";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";

import { InboxOutlined } from "@ant-design/icons";

class DownloadAppForm extends Component {
  constructor() {
    super();

    this.state = {
      id: "",
      fileList: [],
    };

    this.formRef = React.createRef();
  }

  handleSubmit = () => {
    this.formRef.current.validateFields().then((values) => {
      const formData = new FormData();

      formData.append("url", values.url);

      if (values.logo && values.logo.fileList && values.logo.fileList.length)
        formData.append("logo", values.logo.file, values.logo.file.name);

      if (this.state.id) {
        this.props.onSubmit(formData, this.state.id);
      } else {
        this.props.onSubmit(formData);
      }
    });
  };

  handleWillUnmount = () => {
    this.setState({
      id: "",
      fileList: [],
    });
    this.formRef.current.resetFields();
  };

  handleDidMount = (data = {}) => {
    this.formRef.current.setFieldsValue(cloneDeep(data));
    this.setState({ editMode: !!data.id, id: data.id });
  };

  render() {
    const { onCancel, submitting, visible } = this.props;
    const { editMode, fileList } = this.state;

    const props = {
      onRemove: (file) => {
        this.setState({ fileList: [] });
      },
      beforeUpload: (file) => {
        this.setState({ fileList: [file] });
        return false;
      },
      showUploadList: {
        showRemoveIcon: editMode,
      },
      fileList,
    };

    return (
      <Modal
        title={editMode ? Resources.edit : Resources.add}
        visible={visible}
        onOk={this.handleSubmit}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        okButtonProps={{ loading: submitting }}
        cancelButtonProps={{ disabled: submitting }}
        width={360}
      >
        <Form ref={this.formRef} layout="vertical">
          <Row>
            <Col xs={24}>
              <Form.Item
                name="logo"
                label={Resources.image}
                rules={editMode ? [] : Rules.required}
              >
                <Upload.Dragger {...props}>
                  <p className="ant-upload-drag-icon">
                    <InboxOutlined />
                  </p>
                  <p className="ant-upload-hint">{Resources.uploadText}</p>
                </Upload.Dragger>
              </Form.Item>
            </Col>
            <Col xs={24}>
              <Form.Item
                name="url"
                label={Resources.url}
                rules={Rules.required}
              >
                <Input type="text" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default DownloadAppForm;
